@if (label(); as label) {
  <label [for]="innerId()">{{ label }}</label>
}
<p-toggleswitch
  [(ngModel)]="model"
  [inputId]="innerId()"
/>
